import React from 'react';
import PropTypes from 'prop-types';
import { Dot, useI18n } from '@jarvis/react-portal-addons';
import { StatusContainer, StatusText } from './styles';
import { STATUS } from '../utils';

export const StatusColumn = ({ type, 'data-testid': dataTestId }) => {
  const { t } = useI18n();

  const statusInfo = Object.values(STATUS).find(s => s.type === type);

  if (statusInfo) {
    return (
      <StatusContainer data-testid={dataTestId}>
        <Dot data-testid={`${dataTestId}-dot`} primaryColor={statusInfo.color} />
        <StatusText data-testid={`${dataTestId}-text`} className="caption-regular">{t(statusInfo.labelKey)}</StatusText>
      </StatusContainer>
    );
  }

  return null;
};

StatusColumn.propTypes = {
  type: PropTypes.string.isRequired,
  'data-testid': PropTypes.string,
};

StatusColumn.defaultProps = {
  'data-testid': '',
};

export default StatusColumn;
